var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#DEF2EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5926 11.0272C22.6804 10.0423 21.4063 9.5 20.0001 9.5C18.5863 9.5 17.308 10.0391 16.4 11.0178C15.4822 12.0073 15.035 13.3522 15.14 14.8044C15.3482 17.6694 17.5283 20 20.0001 20C22.4718 20 24.6482 17.6698 24.8596 14.8053C24.966 13.3662 24.516 12.0242 23.5926 11.0272Z",
    fill: "#5CBDA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 30.5H11.75C11.5341 30.5028 11.3202 30.4574 11.1239 30.3672C10.9277 30.2769 10.7541 30.1441 10.6156 29.9783C10.311 29.6141 10.1881 29.1167 10.2791 28.6137C10.6747 26.4191 11.9094 24.5755 13.85 23.2812C15.5741 22.1323 17.758 21.5 20 21.5C22.2421 21.5 24.426 22.1328 26.15 23.2812C28.0906 24.575 29.3253 26.4186 29.721 28.6133C29.8119 29.1162 29.6891 29.6136 29.3844 29.9778C29.246 30.1437 29.0724 30.2766 28.8762 30.367C28.6799 30.4573 28.466 30.5028 28.25 30.5Z",
    fill: "#5CBDA1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.45aa6981.svg";
export { ForwardRef as ReactComponent };